/**
 * Internal developer override that exposes user impersonation controls in Settings.
 * Deliberately obscured so it is not obvious/guessable in the console or storage inspector.
 * To enable: `window.__mk8p_wS2__ = true` in the browser console.
 */
export const IMPERSONATION_WINDOW_KEY = '__mk8p_wS2__';

type WindowWithImpersonation = Window & {
  [IMPERSONATION_WINDOW_KEY]?: boolean;
};

export function isImpersonationEnabled(): boolean {
  return localStorage.getItem(IMPERSONATION_WINDOW_KEY) === 'true';
}

export function installImpersonationToggle(): void {
  const w = window as WindowWithImpersonation;

  Object.defineProperty(w, IMPERSONATION_WINDOW_KEY, {
    get: () => isImpersonationEnabled(),
    set: (value: boolean) => {
      if (value) {
        localStorage.setItem(IMPERSONATION_WINDOW_KEY, 'true');
      } else {
        localStorage.removeItem(IMPERSONATION_WINDOW_KEY);
      }
    },
    configurable: true,
  });
}
